import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi2";

const steps = [
  {
    id: "enquire",
    step: 1,
    title: "Enquire or apply",
    text: "Share your child’s grade, goals, and timeline. You can start with a short form or speak with our admissions team.",
  },
  {
    id: "counsel",
    step: 2,
    title: "Counselling & stream fit",
    text: "We confirm board options, stream choice (Commerce, Science, or Arts), and subject combinations that match university plans.",
  },
  {
    id: "documents",
    step: 3,
    title: "Documents & verification",
    text: "Submit prior school records and ID as requested. We verify eligibility and outline any credit transfer or bridging steps.",
  },
  {
    id: "enrol",
    step: 4,
    title: "Enrolment & onboarding",
    text: "Complete enrolment, receive your schedule and learning access, and meet your academic point of contact.",
  },
];

function AdmissionProcessSection({
  sectionTitle = "Admission process",
  intro = "From your first conversation to your first class, here is how enrolling at Altus typically works.",
  headingId = "admission-process-heading",
}) {
  return (
    <section
      className="relative overflow-hidden bg-gradient-to-b from-white via-brand-light/35 to-brand-light/55 py-16 sm:py-20 lg:py-24"
      aria-labelledby={headingId}
    >
      <div
        className="pointer-events-none absolute right-0 top-1/2 h-80 w-80 -translate-y-1/2 translate-x-1/3 rounded-full bg-brand/[0.06] blur-3xl"
        aria-hidden
      />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
        <header className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
            Admissions
          </p>
          <h2
            id={headingId}
            className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:mt-5 sm:text-4xl md:text-[2.375rem] md:leading-tight"
          >
            {sectionTitle}
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-pretty text-base leading-relaxed text-ink/75 sm:mt-6">
            {intro}
          </p>
        </header>

        <ol className="relative mx-auto mt-14 max-w-3xl space-y-0 sm:mt-16">
          {steps.map((item, index) => (
            <li
              key={item.id}
              className="relative flex gap-5 pb-10 pl-2 sm:gap-8 sm:pb-12 last:pb-0"
            >
              {index < steps.length - 1 ? (
                <div
                  className="absolute left-[1.125rem] top-10 bottom-0 w-px bg-gradient-to-b from-brand/35 via-brand/20 to-transparent sm:left-5"
                  aria-hidden
                />
              ) : null}
              <div className="relative z-[1] flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-brand to-brand-dark text-sm font-bold text-white shadow-md shadow-brand/25 sm:h-11 sm:w-11 sm:text-base">
                {item.step}
              </div>
              <div className="min-w-0 pt-0.5">
                <h3 className="text-lg font-bold tracking-tight text-ink sm:text-xl">
                  {item.title}
                </h3>
                <p className="mt-2 text-pretty text-sm leading-relaxed text-ink/72 sm:text-[0.9375rem]">
                  {item.text}
                </p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mx-auto mt-12 flex max-w-3xl flex-col items-stretch justify-center gap-3 sm:mt-14 sm:flex-row sm:gap-4">
          <Link
            to="https://forms.gle/m1PLhs8jVYXHs1cWA"
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-brand px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-brand/25 transition hover:bg-brand-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand sm:text-base"
          >
            Start application
            <HiArrowRight className="h-5 w-5" aria-hidden />
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center rounded-2xl border-2 border-brand/25 bg-white px-6 py-3.5 text-sm font-semibold text-brand transition hover:border-brand/40 hover:bg-brand-light/50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand sm:text-base"
          >
            Talk to admissions
          </Link>
        </div>
      </div>
    </section>
  );
}

export default AdmissionProcessSection;
